<template>
  <v-app>
    <component :is="layout" class="font-weight-light"></component>
  </v-app>
</template>

<script>
// import Vue from "vue";
import DefaultLayout from "@/layout/DefaultLayout.vue";
import FullPageLayout from "@/layout/FullPageLayout.vue";
import { EventBus } from "./event-bus";

export default {
  name: "App",

  data: () => ({
    //
  }),

  components: {
    DefaultLayout,
    FullPageLayout
  },

  computed: {
    layout() {
      let layout = this.$route.meta.layout || "default";
      if (layout === "default") {
        return "DefaultLayout";
      }
      return "FullPageLayout";
    }
  },

  beforeDestroy() {
    EventBus.$off("change-locale");
    // EventBus.$off("signout");
    // EventBus.$off("update-local-profile");
  },
  mounted() {
    EventBus.$on("change-locale", locale => {
      this.$vuetify.lang.current = locale;
      localStorage.setItem("locale", locale);
    });

    this.$vuetify.lang.current = localStorage.getItem("local") || "en";
  }
};
</script>

<style scoped>
#app {
  background-color: #e7e7e7;
  font-size: 1.125rem !important;
}
</style>
<style>
.v-data-table th {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 1rem !important;
  height: 3rem;
}

.v-tab.v-tab {
  color: inherit;
  font-size: 1rem !important;
}

.v-data-table td {
  font-size: 1rem !important;
}

.v-btn.v-size--default {
  font-size: 0.9375rem !important;
}

.v-chip.v-size--default {
  border-radius: 1rem;
  font-size: 0.9375rem !important;
  height: 2rem;
}

.v-chip.v-size--small {
  border-radius: 0.75rem;
  font-size: 0.875rem !important;
  height: 1.5rem;
}

.v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 0 !important;
}

.v-text-field--enclosed .v-input__append-inner,
.v-text-field--enclosed .v-input__append-outer,
.v-text-field--enclosed .v-input__prepend-inner,
.v-text-field--enclosed .v-input__prepend-outer,
.v-text-field--full-width .v-input__append-inner,
.v-text-field--full-width .v-input__append-outer,
.v-text-field--full-width .v-input__prepend-inner,
.v-text-field--full-width .v-input__prepend-outer {
  margin-top: 9px !important;
}

.v-application--wrap {
  background: #f0f2f5;
}

.bg-custom {
  background: #f0f2f5 !important;
}

.theme--light.v-data-table {
  box-shadow: none !important;
  border-radius: 0 !important;
}

.v-data-table-header {
  background: #fafafa !important;
}

.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
  > .v-input__control
  > .v-input__slot
  fieldset {
  border-color: rgba(0, 0, 0, 0.12);
}

.v-input input {
  max-height: 40px !important;
}
.ql-tooltip.ql-editing {
  left: 10px !important;
}
</style>
